import React from 'react';

const SvgEt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ET_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ET_svg__b" fill="#fff">
        <use xlinkHref="#ET_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#ET_svg__a" />
      <path fill="#20AA46" mask="url(#ET_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#E92F3B" mask="url(#ET_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#FADF50" mask="url(#ET_svg__b)" d="M0 6.667h28v6.667H0z" />
      <circle fill="#205CCA" mask="url(#ET_svg__b)" cx={14} cy={10} r={4.667} />
      <path
        d="M15.342 11.848l-.495-1.573 1.325-.98-1.648-.016L14 7.716l-.524 1.563-1.648.015 1.325.981-.495 1.573L14 10.89l1.342.957z"
        stroke="#FFDB3D"
        strokeWidth={0.667}
        mask="url(#ET_svg__b)"
      />
    </g>
  </svg>
);

export default SvgEt;
